import ShoutboxVisualization from './ShoutboxVisualization.container';

export default ShoutboxVisualization;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/shoutboxvisualization/index.js